import { useState, useEffect, useRef } from 'react';

export default function useComponentVisible(initialIsVisible: boolean = false) {
  const [isComponentVisible, setIsComponentVisible] = useState<boolean>(initialIsVisible);
  // HTMLDivElement is probably not the best choice
  const ref = useRef<HTMLDivElement | null>(null);

  function handleHideDropdown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      setIsComponentVisible(false);
    }
  }

  function handleClickOutside(event: MouseEvent) {
    const clickedOnElement = event.target instanceof Element;
    if (!clickedOnElement) {
      return;
    }

    const clickedOutsideRefComponent = ref.current && !ref.current.contains(event.target);
    if (clickedOutsideRefComponent) {
      setIsComponentVisible(false);
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleHideDropdown, true);
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('keydown', handleHideDropdown, true);
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  function toggleVisibility() {
    setIsComponentVisible((prev) => !prev);
  }

  function showComponent() {
    setIsComponentVisible(false);
  }

  function hideComponent() {
    setIsComponentVisible(false);
  }

  return { ref, isComponentVisible, setIsComponentVisible, showComponent, hideComponent, toggleVisibility };
}
